export default __webpack_public_path__ + "static/vidoePoster-cc782f6085272291a289fd2053cbb75c.jpg";